import { gql } from '@apollo/client';
import { BASE_BOX_FIELDS, LOT_FIELDS, BOX_FIELDS_FIELD } from '../queries';
import { USER_NAME_FIELDS } from 'src/models/users/queries';

const BOX_PREVIEW_FIELDS = gql`
  fragment boxPreviewFields on TenderBox {
    ...baseBoxFields
    ...boxFieldsField
    lots {
      ...lotFields
    }
  }
  ${BASE_BOX_FIELDS}
  ${BOX_FIELDS_FIELD}
  ${LOT_FIELDS}
`;
export const TENDER_PREVIEW_FIELDS = gql`
  fragment tenderPreviewFields on Tender {
    id
    isRead
    isInProgress
    isFilledData
    procurementStatus
    isStarred
    assignedTo {
      ...userNameFields
    }
    timeline {
      id
      availableDate {
        ...boxPreviewFields
      }
      contractStartAndEndStart {
        ...boxPreviewFields
      }
      contractStartAndEndEnd {
        ...boxPreviewFields
      }
      deadlineOfClarificationQuestions {
        ...boxPreviewFields
      }
      deadline {
        ...boxPreviewFields
      }
    }
    lots {
      ...lotFields
    }
    general {
      id
      name {
        ...boxPreviewFields
      }
      introduction {
        ...boxPreviewFields
      }
      description {
        ...boxPreviewFields
      }
      scopeOfContract {
        ...boxPreviewFields
      }
      buyerBoxes {
        ...boxPreviewFields
      }
      contractDurationBoxes {
        ...boxPreviewFields
      }
      locationBoxes {
        ...boxPreviewFields
      }
      placeOfPerformanceNutsCode {
        ...boxPreviewFields
      }
      linkToProcurerBoxes {
        ...boxPreviewFields
      }
      contractValueBoxes {
        ...boxPreviewFields
      }
      contractRenewalBoxes {
        ...boxPreviewFields
      }
      typeOfProcedureBoxes {
        ...boxPreviewFields
      }
      mainCpvCode {
        ...boxPreviewFields
      }
      additionalCpvCode {
        ...boxPreviewFields
      }
    }
    bids {
      id
      itemId
      workspace {
        id
      }
      status {
        id
      }
    }
    rejected(matchingProfileId: $matchingProfileId)
  }
  ${BOX_PREVIEW_FIELDS}
  ${LOT_FIELDS}
  ${USER_NAME_FIELDS}
`;
export const GET_TENDER_PREVIEW = gql`
  query getTenderPreview($procurementId: String!, $matchingProfileId: String) {
    getTender(query: { id: $procurementId }) {
      ...tenderPreviewFields
    }
  }
  ${TENDER_PREVIEW_FIELDS}
`;
